module.exports = __webpack_public_path__ + "static/media/SchoolBanner.7e1447ee.png";